export const isCartExperience = (path = '') => {
  if (!path) {
    return false;
  }
  return path.split(/\/|\?/)?.[1] === 'cart';
};